export default __webpack_public_path__ + "static/media/rearrange-delete-icon.fd7ed030.svg";